const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import YXXTableView from "./yxx_table_view";
import YXXTableModel from "./yxx_table_model";
import YXXTableModuleBase from "./yxx_table_module_base";
import AppData from "../../../public/const/app_data";
import ModuleManager from "../../../../framework/core/module_manager";
import { RoadMap_yxx } from "../roadmap_yxx/roadmap_yxx";
import { RoadMap_tb } from "../roadmap_tb/roadmap_tb";

@ccclass
@moduleInit("YXXTableModule")
export default class YXXTableModule extends YXXTableModuleBase<YXXTableView, YXXTableModel>  {
    constructor() {
        super()
        if (AppData.gameSimpleName == "YXX"){
            this.windowPrefabResPath = 'package/yxx/yxx_table';
            this.betNameList = [1, 2, 3, 4, 5, 6, 12, 13, 14, 15, 16, 23, 24, 25, 26, 34, 35, 36, 45, 46, 56]
        }
        else if (AppData.gameSimpleName == "TB"){
            this.windowPrefabResPath = 'package/yxx/tb_table';
            this.betNameList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 12, 14, 15, 16, 17, 23, 24, 25, 26, 34, 35, 36, 37, 45, 49, 56, 57, 67, 69, 123, 456]
            
        }
        this.viewType = YXXTableView;
        this.modelType = YXXTableModel;

        // ModuleManager.instance.showModule(RoadMap_yxx, "RoadMap_yxx")
    }

    onModuleInit() {
        if(AppData.gameSimpleName == "YXX"){
            ModuleManager.instance.showModule(RoadMap_yxx, "RoadMap_yxx")
        }else if (AppData.gameSimpleName == "TB"){
            ModuleManager.instance.showModule(RoadMap_tb, "RoadMap_tb")
        }
        
    }
}